<template>
	<main class="dashboard">
		<div class="dashboard__cover"></div>
		<div class="dashboard__topper d-flex">
			<aside
				class="dashboard__navigation d-flex flex-column justify-content-between text-light"
			>
				<div class="dashboard__navigation__logo">
					<h3 class="dashboard__navigation__logo__bold">
						M.
					</h3>
				</div>

				<ul
					class="dashboard__navigation__actions d-flex flex-column align-items-center justify-content-between"
				>
					<li class="dashboard__navigation__actions__item">
						<button
							class="dashboard__navigation__actions__item__button d-flex justify-content-center align-items-center"
						>
							<i
								class="dashboard__navigation__actions__item__icon fal fa-user-friends"
							></i>
						</button>
					</li>
					<li class="dashboard__navigation__actions__item">
						<button
							class="dashboard__navigation__actions__item__button d-flex justify-content-center align-items-center"
						>
							<i
								class="dashboard__navigation__actions__item__icon fal fa-phone-alt"
							></i>
						</button>
					</li>
					<li class="dashboard__navigation__actions__item">
						<button
							class="dashboard__navigation__actions__item__button d-flex justify-content-center align-items-center"
						>
							<i
								class="dashboard__navigation__actions__item__icon fal fa-comment-dots"
							></i>
						</button>
					</li>
					<li class="dashboard__navigation__actions__item">
						<button
							class="dashboard__navigation__actions__item__button d-flex justify-content-center align-items-center"
						>
							<i
								class="dashboard__navigation__actions__item__icon fal fa-cog"
							></i>
						</button>
					</li>
				</ul>

				<div class="dashboard__navigation__theme">
					<button
						class="dashboard__navigation__actions__item__button d-flex justify-content-center align-items-center"
					>
						<i
							class="dashboard__navigation__actions__item__icon fa fa-sun"
						></i>
					</button>
				</div>
			</aside>
			<section class="dashboard__content text-light">
				<div
					class="dashboard__content__profile d-flex justify-content-between align-items-center"
				>
					<div
						class="dashboard__content__profile__inner-wrap d-flex align-items-center"
					>
						<!-- <vs-avatar size="50" badge badge-color="success" circle>
							<img
								src="https://randomuser.me/api/portraits/men/82.jpg"
								alt=""
							/>
						</vs-avatar> -->
						<profile-picture
							badge
							class="mr-3"
							:text="MY_PROFILE.name"
							:img="MY_PROFILE.profilePicture"
						></profile-picture>
						<div
							class="dashboard__content__profile__name-nickname "
						>
							<p
								class="dashboard__content__profile__name m-0 mt-1"
							>
								{{ MY_PROFILE.name }}
							</p>

							<p
								class="dashboard__content__profile__nickname m-0 "
							>
								@{{ MY_PROFILE.nickname }}
							</p>
						</div>
					</div>

					<div class="dashboard__content__profile__more-dropdown">
						<button class="chat-hoverable-btn">
							<i class="fal fa-2x fa-ellipsis-h"></i>
						</button>
					</div>
				</div>
				<search></search>
				<div
					class="dashboard__content__stories d-flex justify-content-between"
				>
					<div class="dashboard__content__stories__item first-item">
						<div class="dashboard__content__stories__add">
							<i class="fal fa-plus"></i>
						</div>
						<p class="dashboard__content__stories__item__owner">
							My Story
						</p>
					</div>
					<div class="dashboard__content__stories__item ">
						<vs-avatar
							class="dashboard__content__stories__item__avatar"
							size="60"
							history
							history-gradient
							circle
							dark
						>
							<img
								src="https://randomuser.me/api/portraits/women/80.jpg"
								alt=""
							/>
						</vs-avatar>
						<p class="dashboard__content__stories__item__owner">
							Kate D.
						</p>
					</div>
					<div class="dashboard__content__stories__item ">
						<vs-avatar
							class="dashboard__content__stories__item__avatar"
							size="60"
							history
							history-gradient
							circle
							dark
						>
							<img
								src="https://randomuser.me/api/portraits/men/80.jpg"
								alt=""
							/>
						</vs-avatar>
						<p class="dashboard__content__stories__item__owner">
							John B.
						</p>
					</div>
					<div class="dashboard__content__stories__item ">
						<vs-avatar
							class="dashboard__content__stories__item__avatar"
							size="60"
							history
							history-gradient
							circle
							dark
						>
							<img
								src="https://randomuser.me/api/portraits/men/40.jpg"
								alt=""
							/>
						</vs-avatar>
						<p class="dashboard__content__stories__item__owner">
							Big Ed
						</p>
					</div>
				</div>
				<simplebar class="dashboard__content__chats d-flex flex-column">
					<friend-card
						v-for="friend in MY_PROFILE.friends"
						:key="friend._id"
						:friend="friend"
					></friend-card>
				</simplebar>
			</section>
			<!-- <div class="h-100 w-100 position-relative"> -->
			<chat-view
				v-if="chat && Object.keys(chat).length > 0"
				ref="chatView"
				:messagesLoading="messagesLoading"
				:chat="chat"
			></chat-view>
			<div
				v-else-if="!friend"
				class="w-100 h-100 d-flex justify-content-center align-items-center"
			>
				<h6 class="text-light">
					Please select a chat to message with.
				</h6>
			</div>
			<!-- </div> -->
		</div>
	</main>
</template>

<script>
import { mapActions, mapState } from "vuex"
import simplebar from "simplebar-vue"
import FriendCard from "@/components/Dashboard/FriendCard"
import ProfilePicture from "@/components/Dashboard/ProfilePicture"
import Search from "@/components/Dashboard/Search"
import ChatView from "@/components/Dashboard/ChatView"

export default {
	data: () => ({
		visitedChats: [],
		chat: {},
		messagesLoading: false,
		connected: true
	}),
	components: {
		simplebar,
		FriendCard,
		ProfilePicture,
		Search,
		ChatView
	},

	computed: {
		...mapState(["MY_PROFILE"]),
		friend() {
			return this.$route.params.nickname
		}
	},
	methods: {
		...mapActions(["GET_MY_PROFILE"]),
		...mapActions("sockets", ["LOAD_MESSAGES"]),

		async findChat(newVal) {
			if (newVal) {
				this.chat = this.MY_PROFILE.friends.filter(
					(friend) => friend.nickname === newVal
				)[0]
				if (!this.visitedChats.includes(newVal)) {
					this.messagesLoading = true
					this.visitedChats.push(newVal)
					await this.LOAD_MESSAGES(newVal)
					this.messagesLoading = false
				}
				await this.scrollBottom()
			}
		},
		async scrollBottom() {
			if (this.friend) {
				await this.$refs.chatView.scrollBottom()
			}
		},
		async connectSocket() {
			this.$socket.auth = { nickname: this.MY_PROFILE.nickname }
			await Promise.all([
				this.$socket.connect(),
				this.$socket.emit("online", { userId: this.MY_PROFILE._id })
			])
		}
	},

	async created() {
		await this.GET_MY_PROFILE()
		await this.connectSocket()
		this.findChat(this.friend)
	},
	mounted() {
		console.log(this.MY_PROFILE)
		if (!this.MY_PROFILE.name) {
			this.$router.push({ name: "login" })
		}
	},

	watch: {
		async "$route.params.nickname"(newVal) {
			await this.findChat(newVal)
		}
	}
}
</script>

<style src="simplebar-vue/dist/simplebar.min.css"></style>

<style lang="scss">
@import "../assets/styles/scss/dashboard";
</style>
